import { combineReducers } from 'redux';

// new slices
import { statsLeadersReducer } from './stats-leaders';
import { playerComparisonReducer } from './player-comparison';
import { careerAndSeasonStatsReducer } from './career-and-season-stats';
import { performanceChartReducer } from './performance-chart';
import { statComparisonReducer } from './stat-comparison';
import { glossaryReducer } from './glossary';

const rootReducer = combineReducers({
    statsLeaders: statsLeadersReducer,
    glossary: glossaryReducer,
    careerAndSeasonStats: careerAndSeasonStatsReducer,
    performanceChart: performanceChartReducer,
    playerComparison: playerComparisonReducer,
    statComparison: statComparisonReducer
});

// @ts-expect-error
if (window.PULSE.app.redux) {
    // @ts-expect-error
    window.PULSE.app.redux.reducers.statspro = { root: rootReducer };
} else {
    // @ts-expect-error
    window.PULSE.app.redux = {
        reducers: {
            statspro: {
                root: rootReducer
            }
        }
    };
}
